/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Timeline_Legacy_Zoom_Seconds_TitleInputs */

const en_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} seconds`)
};

const fr_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} secondes`)
};

const de_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} Sekunden`)
};

const it_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} secondi`)
};

const ru_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} секунд`)
};

const es_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} segundos`)
};

const zh_cn2_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`缩放 ${i?.seconds} 秒`)
};

const ja_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ズーム ${i?.seconds} 秒`)
};

const hi_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ज़ूम ${i?.seconds} सेकंड`)
};

const pt_pt2_timeline_legacy_zoom_seconds_title = /** @type {(inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoom ${i?.seconds} segundos`)
};

/**
* | output |
* | --- |
* | "Zoom {seconds} seconds" |
*
* @param {Timeline_Legacy_Zoom_Seconds_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_zoom_seconds_title = /** @type {((inputs: Timeline_Legacy_Zoom_Seconds_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Zoom_Seconds_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "de") return de_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "it") return it_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "ru") return ru_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "es") return es_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "ja") return ja_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "hi") return hi_timeline_legacy_zoom_seconds_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_legacy_zoom_seconds_title(inputs)
	return en_timeline_legacy_zoom_seconds_title(inputs)
});